import React from "react";
import { MarkBadge, MarkGrowth, MarkShield, Wordmark } from "../components/LogoConcepts";

const options = [
  {
    id: 1,
    name: "Option 1 — Monogram Badge",
    note: "Bold, app-icon friendly. A confident navy badge with a gold-framed 'BE'. Reads instantly at any size.",
    Mark: MarkBadge,
  },
  {
    id: 2,
    name: "Option 2 — Ascending Growth",
    note: "Rising bars + arrow = growing your B-BBEE score. Modern, dynamic and clearly 'consulting'.",
    Mark: MarkGrowth,
  },
  {
    id: 3,
    name: "Option 3 — Compliance Shield",
    note: "A shield with a gold check = trust, protection and compliance. Reassuring and premium.",
    Mark: MarkShield,
  },
];

export default function LogoOptions() {
  return (
    <div className="py-14">
      <div className="container-x">
        <div className="text-center mb-12">
          <div className="eyebrow justify-center mb-3" style={{ display: "inline-flex" }}>Fresh Logo Concepts</div>
          <h1 className="font-head text-3xl md:text-4xl font-bold text-[#0B1F3A]">Pick your favourite direction</h1>
          <p className="mt-3 text-slate-600 max-w-2xl mx-auto">
            Three fresh, original marks in your brand palette (Navy #0B1F3A · Blue #184E9E · Gold #D4AF37).
            Each is shown as an icon, on light and dark, and as a full lockup. Tell me the number you like
            and I'll roll it out across the whole site.
          </p>
        </div>

        <div className="space-y-8">
          {options.map(({ id, name, note, Mark }) => (
            <div key={id} className="rounded-2xl border border-slate-200 overflow-hidden">
              <div className="px-6 py-4 bg-[#F6F7F9] border-b border-slate-200 flex items-center justify-between">
                <h2 className="font-head font-bold text-[#0B1F3A] text-lg">{name}</h2>
                <span className="text-2xl font-head font-extrabold text-[#D4AF37]">#{id}</span>
              </div>
              <p className="px-6 pt-4 text-sm text-slate-500">{note}</p>

              <div className="grid md:grid-cols-2">
                {/* Light */}
                <div className="p-8 flex items-center gap-6">
                  <Mark size={72} />
                  <Wordmark />
                </div>
                {/* Dark */}
                <div className="p-8 flex items-center gap-6 bg-[#0B1F3A]">
                  <Mark size={72} onDark />
                  <Wordmark onDark />
                </div>
              </div>

              {/* icon sizes */}
              <div className="px-6 py-5 border-t border-slate-200 flex items-center gap-6">
                <span className="text-xs uppercase tracking-widest text-slate-400">Icon sizes</span>
                <Mark size={48} />
                <Mark size={32} />
                <Mark size={22} />
                <div className="w-10 h-10 rounded-lg bg-[#0B1F3A] grid place-items-center">
                  <Mark size={30} onDark />
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-slate-500 mt-10">
          Reply with <b className="text-[#0B1F3A]">"Option 1", "Option 2" or "Option 3"</b> (or mix &amp; match)
          and I'll apply it everywhere — header, footer, favicon and affidavit PDFs.
        </p>
      </div>
    </div>
  );
}
